import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MoneyFormatProvider } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
export function SeagullMoneyFormatProvider(param) {
    let { children } = param;
    const { SALES_TAX } = useFeatureFlags();
    const moneyFormat = useMemo(()=>({
            alwaysShowCents: !!SALES_TAX
        }), [
        SALES_TAX
    ]);
    return /*#__PURE__*/ _jsx(MoneyFormatProvider, {
        value: moneyFormat,
        children: children
    });
}
